<template src="./template.html"></template>

<script>
import Datepicker from 'vuejs-datepicker'
import SingleSelectInput from '@/components/ui/SingleSelectInput'

export default {
  name: 'ChildrenEditSection',
  components: {
    SingleSelectInput,
    Datepicker,
  },
  props: {
    data: Object,
    methods: Object,
  },
  methods: {
    onUpdateGender(id, args) {
      this.methods.onUpdateGender(id, args)
      this.$forceUpdate()
    },
    setDefaultGender(childGender) {
      const index = this.data.genderOptions.findIndex(gender => gender.key === childGender)
      return this.data.genderOptions[index]
    },
  },
}
</script>
